import React from 'react';
import Submenu from "../shared/Submenu.js";

export default function LogsDigitalSubmenu({ CompanyId }){
  return (
    <Submenu items={[
      { to: `/digitals`, label: 'Logs',end: true },
      { to: `/digitals/implementation`, label: 'Implementaciones' },
    ]}/>
  )
}
 
